import { createRouter, createWebHistory } from 'vue-router'
import store from '../store'          // ← here
import Login from '@/views/LoginPage.vue'
import Dashboard from '@/views/DashboardPage.vue'
import LeadsTable from '@/views/LeadsTable.vue'
import LeadsFocused from '@/views/LeadsFocused.vue'
import Dialer from '@/views/DialerPage.vue'
import CallLogs from '@/views/CallLogs.vue'
import Kanban from '@/views/KanbanView.vue'
import Invoices from '@/views/InvoicesView.vue'
import Inventory from '@/views/InventoryView.vue'
import ShippingLabels from '@/views/ShippingLabels.vue'
import GapsView from '@/views/GapsView.vue'
import CallReviewView from '@/views/CallReviewView.vue'

const routes = [
  { path: '/', redirect: '/login' },
  { path: '/login', name: 'Login', component: Login },
  {
    path: '/call-review',
    name: 'CallReview',
    component: CallReviewView,
    meta: { requiresAuth: true }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: { requiresAuth: true }
  },
  {
    path: '/leads-table',
    name: 'LeadsTable',
    component: LeadsTable,
    meta: { requiresAuth: true }
  },
  {
    path: '/leads-focused',
    name: 'LeadsFocused',
    component: LeadsFocused,
    meta: { requiresAuth: true }
  },
  {
    path: '/dialer',
    name: 'Dialer',
    component: Dialer,
    meta: { requiresAuth: true }
  },

  {
    path: '/call-logs',
    name: 'call-logs',
    component: CallLogs,
    meta: { requiresAuth: true }
  },
  {
    path: '/kanban',
    name: 'kanban',
    component: Kanban,
    meta: { requiresAuth: true }
  },
  {
    path: '/invoices',
    name: 'Invoices',
    component: Invoices,
    meta: { requiresAuth: true }
  },
  {
    path: '/inventory',
    name: 'Inventory',
    component: Inventory,
    meta: { requiresAuth: true }
  },
  {
    path: '/shipping-labels',
    name: 'ShippingLabels',
    component: ShippingLabels,
    meta: { requiresAuth: true }
  },
  {
    path: '/gaps',
    name: 'Gaps',
    component: GapsView,
    meta: { requiresAuth: true }
  },
  {
    path: '/public/invoice/:invoiceId',
    name: 'PublicInvoiceDetails',
    component: () => import('@/views/PublicInvoiceDetails.vue')
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  const isLoggedIn = !!store.state.auth.token
  if (to.meta.requiresAuth && !isLoggedIn) return next({ name: 'Login' })

  const currentUser = store.getters['auth/currentUser']
  const userId = Number(currentUser?.id)

  // Restrict Inventory route for specific users (30, 31)
  if (to.name === 'Inventory' && [30, 31].includes(userId)) {
    return next({ name: 'LeadsTable' })
  }

  if (to.name === 'Login' && isLoggedIn) {
    const org = String(currentUser?.organization ?? '').toLowerCase()
    if (org === 'directtide') {
      if ([28, 29, 30, 31].includes(userId)) {
        return next({ name: 'LeadsTable' })
      }
      return next({ name: 'Invoices' })
    }
    return next({ name: 'Dashboard' })
  }
  next()
})

export default router
